import React from 'react';
import { FlatPrimaryButton } from '../Ui';

const PlanHeaders = ({
	projectName,
	downloadLink,
	user,
	duplicationMode,
	onDuplicationClick
}) => {
	const duplicationLabel = duplicationMode ? 'On' : 'Off';

	return (
		<header className="c-plan__headers">
			<div className="u-flex">
				<div className="c-plan__header c-plan__header--project">
					<div>{projectName}</div>
					{user.firstname &&
						<div>
							<a href={downloadLink}>
								<FlatPrimaryButton>
									{' '}Télécharger(.xls){' '}
								</FlatPrimaryButton>
							</a>
						</div>}
				</div>
				<div className="c-plan__header c-plan__header--secondary c-plan__header--roles">
					Clés
				</div>
			</div>
			<div className="u-flex">
				<div className="c-plan__header c-plan__header--secondary c-plan__header--lockings">
					Ouvertures
				</div>
				<div className="c-plan__header c-plan__header--secondary c-plan__header--rights">
					<div>Tout</div>
					<div>sélectionner</div>
				</div>
			</div>
		</header>
	);
};

const ProjectHeader = ({}) => <header />;

export default PlanHeaders;



// WEBPACK FOOTER //
// ./src/js/plan/PlanHeaders.js